( function( app ) {
  const COMPONENT = {
    initEventListeners: function() {
      const _this = this;
      const $form = $( '#product-variation-form' );
      let selectedFields = {
        color: {
          required: true,
          value: $( '.attribute-color input:checked' ).val() || null,
        },
        size: {
          required: false,
          value: $( '.attribute-size input:checked' ).val() || null,
        },
        width: {
          required: false,
          value: $( '.attribute-width input:checked' ).val() || null,
        },
        store_id: {
          required: false,
          value: $( '[name="store_id"]:checked' ).val() || null,
          on: $( '[name="store_id"]:checked' ).attr( 'checked' ) === 'checked',
          type: 'checkbox',
        },
      };

      $form.on( 'change', 'input', function( e ) {
        const input = e.target;
        if ( selectedFields[input.name].type === 'checkbox' || selectedFields[input.name].value !== input.value ) {
          if ( selectedFields[input.name].type === 'checkbox' ) {
            selectedFields[input.name].on = input.checked === 'checked';
          } else {
            selectedFields[input.name].value = input.value;
          }
          $form.submit();
        }
      } );

      $form.on( 'click', 'input[type="radio"]', function( e ) {
        const radio = e.target;
        if ( !selectedFields[radio.name].required && selectedFields[radio.name].value === radio.value ) {
          radio.checked = false;
          selectedFields[radio.name].value = null;
          $form.submit();
        }
      } );

      window.addEventListener( 'preferredLocationChanged', function( e ) {
        selectedFields.store_id.value = $( '[name="store_id"]:checked' ).val() || null;
        if ( selectedFields.store_id?.on ) {
          $form.submit();
        }
      } );

      $form.on( 'submit', function( e ) {
        e.preventDefault();
        const formData = $form.serialize();

        $.get( $form.attr( 'action' ), formData, function( response ) {
          const newProductHtml = $( response ).find( '.ll-woocommerce.ll-product .product' );
          const newDesktopImages = $( response ).find( '.ll-woocommerce.ll-product .product-desktop-gallery' );
          const newMobileImages = $( response ).find( '.ll-woocommerce.ll-product .product-mobile-gallery' );
          const newColorName = $( response ).find( '#product-variation-form .fieldset-color legend' );
          const newColors = $( response ).find( '#product-variation-form .attribute-color' );
          const newSizes = $( response ).find( '#product-variation-form .attribute-size' );
          const newWidths = $( response ).find( '#product-variation-form .attribute-width' );
          const newAddToCart = $( response ).find( '.ll-woocommerce.ll-product .product form.cart' );
          const newPrice = $( response ).find( '.ll-woocommerce.ll-product .product [data-wc-price]' );

          if ( newProductHtml.length ) {
            $( '.ll-woocommerce.ll-product .product-desktop-gallery' ).replaceWith( newDesktopImages );
            $( '.ll-woocommerce.ll-product .product-mobile-gallery' ).replaceWith( newMobileImages );
            $( '#product-variation-form .fieldset-color legend' ).replaceWith( newColorName );
            $( '#product-variation-form .attribute-color' ).replaceWith( newColors );
            $( '#product-variation-form .attribute-size' ).replaceWith( newSizes );
            $( '#product-variation-form .attribute-width' ).replaceWith( newWidths );
            $( '.ll-woocommerce.ll-product .product form.cart' ).replaceWith( newAddToCart );
            $( '.ll-woocommerce.ll-product .product [data-wc-price]' ).replaceWith( newPrice );

            selectedFields = {
              color: {
                required: true,
                value: $( '.attribute-color input:checked' ).val() || null,
              },
              size: {
                required: false,
                value: $( '.attribute-size input:checked' ).val() || null,
              },
              width: {
                required: false,
                value: $( '.attribute-width input:checked' ).val() || null,
              },
              store_id: {
                required: false,
                value: $( '[name="store_id"]:checked' ).val() || null,
                on: $( '[name="store_id"]:checked' ).attr( 'checked' ),
                type: 'checkbox',
              },
            };

            const searchParams = new URLSearchParams( formData );
            const queryString = searchParams.toString();
            const newUrl = `${window.location.pathname}${queryString ? '?' + queryString : ''}`;
            window.history.replaceState( {page: newUrl}, '', newUrl );
          }
        } );
      } );
    },
    init: function() {
      this.initEventListeners();
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'product', COMPONENT );
} )( app );
